import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import ReactGA from 'react-ga';

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

ReactGA.initialize(process.env.REACT_APP_ANALYTICS_ID);

import('./App').then(async ({ default: App }) => {
  const blobBaseURL = process.env.REACT_APP_BLOB_STORAGE_BASE_URL;
  window.activeLanguage = navigator.language || navigator.userLanguage;

  const { data: ptBR } = await axios.get(`${blobBaseURL}/i18n/pt-BR.json`);
  const { data: enUS } = await axios.get(`${blobBaseURL}/i18n/en-US.json`);
  const { data: trTR } = await axios.get(`${blobBaseURL}/i18n/tr-TR.json`);
  const { data: esES } = await axios.get(`${blobBaseURL}/i18n/es-ES.json`);
  const { data: frFR } = await axios.get(`${blobBaseURL}/i18n/fr-FR.json`);
  const { data: hat } = await axios.get(`${blobBaseURL}/i18n/hat.json`);

  const resources = {
    'pt-BR': { translation: ptBR },
    en: { translation: enUS },
    tr: { translation: trTR },
    es: { translation: esES },
    fr: { translation: frFR },
    hat: { translation: hat },
  };

  i18n.use(initReactI18next).init({
    lng: 'pt-BR',
    resources,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

  ReactDOM.render(
    <React.Fragment>
      <App />
    </React.Fragment>,
    document.getElementById('root'),
  );
});
